import { createTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const appTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#FFD700",
      light: "#FFDF33",
      dark: "#D4B400",
      contrastText: "#000000",
    },
    secondary: {
      main: "#9E9E9E",
      light: "#BDBDBD",
      dark: "#757575",
      contrastText: "#FFFFFF",
    },
    error: { main: "#f44336" },
    warning: { main: "#ffa726" },
    info: { main: "#757575" },
    success: { main: "#66bb6a" },
    background: {
      default: "#121212",
      paper: "#1C1C1C",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#BBBBBB",
    },
  },
  typography: {
    fontFamily: '"Poppins","Roboto","Helvetica","Arial",sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: "0.02em",
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage:
            "linear-gradient(135deg, rgba(34,34,34,0.9) 0%, rgba(17,17,17,0.9) 100%)",
          backdropFilter: "blur(5px)",
          borderRadius: "12px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: alpha("#1C1C1C", 0.3),
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: alpha("#FFD700", 0.5),
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFD700",
            },
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});
